import React, { FunctionComponent, memo } from 'react'

import LoadingIcon from '@/atoms/icons/loading.svg'

import { SpinnerWrapper } from './styled-spinner'

interface Props {
  overlay?: boolean
}

const Spinner: FunctionComponent<Props> = ({ overlay = false }) => (
  <SpinnerWrapper $overlay={overlay}>
    <LoadingIcon />
  </SpinnerWrapper>
)

Spinner.displayName = 'Spinner'

export default memo(Spinner)
